import { WaterfallChart } from '@/common/dashboard/charts/WaterfallChart';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useState } from 'react';

export const DemReconDiscrepancyDriversChart = ({ prodIds }) => {
  const rsrc = useRsrc();
  const [data, setData] = useState();

  useEffect(() => {
    const reqParam = { prodIds };
    rsrc.data('gtn', 'RECON_DISCREPANCY_DRIVERS_DATA_PLUGIN', reqParam).then(res => {
      setData(res);
    });
  }, [prodIds]);

  if (!data) return null;

  return (
    <WaterfallChart
      data={data}
      dataLabels={true}
    />
  )

};
